import { useQuery } from "@apollo/client";
import { getFragmentData, graphql } from "gql/apollo";
import {
	impactAgentFieldsFragmentDoc,
	ListImpactAgentsParams,
} from "gql/apollo/graphql";
import { useHasFeature } from "ui-library/HasFeature";

export const ListImpactAgents = graphql(/* GraphQL */ `
	query ListImpactAgents($params: ListImpactAgentsParams!) {
		listImpactAgents(params: $params) {
			...impactAgentFields
		}
	}
`);

export const useListImpactAgents = (params: ListImpactAgentsParams = {}) => {
	const hasImpactAgents = useHasFeature("allow_impact_agent");

	const { data, loading, error } = useQuery(ListImpactAgents, {
		variables: { params },
		skip: !hasImpactAgents,
	});

	return {
		impactAgents:
			getFragmentData(impactAgentFieldsFragmentDoc, data?.listImpactAgents) ??
			[],
		loading,
		error,
	};
};
